module.exports = "/_next/static/images/Tokens-a849c46dc05bb9e134cfb8b0fd39ff30.png";